import { cn } from '@/lib/utils'
import { CircleAlert, TriangleAlert } from 'lucide-react'

export type WarningBannerType = 'PROFILE_DISABLED' | 'SUBSCRIPTION_EXPIRED'

type Severity = 'info' | 'warning' | 'danger'

const bannerByType: Record<
  WarningBannerType,
  { severity: Severity; message: string }
> = {
  PROFILE_DISABLED: {
    severity: 'danger',
    message: 'Your profile is set to disabled, re-enable it in profile settings.',
  },
  SUBSCRIPTION_EXPIRED: { /* Example of a different banner type, currently unused */
    severity: 'warning',
    message: 'Your subscription has expired, visit Manage Plan to renew.',
  },
}

const severityClassNames: Record<Severity, string> = {
  info: 'bg-lilac-900 text-blueviolet',
  warning: 'bg-warning text-night-900',
  danger: 'bg-error text-white',
}

export interface WarningBannerProps {
  warningType: WarningBannerType
}

/*
  Top of screen banner for important user account warnings/messages
*/
export function WarningBanner({ warningType }: WarningBannerProps) {
  const { severity, message } = bannerByType[warningType]

  const AlertIcon = severity === 'danger' ? TriangleAlert : CircleAlert

  return (
    <div
      className={cn(
        'px-4 py-1 text-center sm:py-2',
        severityClassNames[severity],
      )}
    >
      <p className="text-sm sm:text-base">
        <AlertIcon
          className="mr-1.5 mb-0.5 inline-block size-4 align-middle sm:mr-2 sm:size-5"
          aria-hidden
        />
        {message}
      </p>
    </div>
  )
}
